<template>
  <span class="pa-0 ma-0">
    <v-progress-linear :active="loading" indeterminate></v-progress-linear>
    <v-row full-height>
      <v-col>
        <v-sheet tile class="d-flex justify-center align-center pa-4" color="primary" dark>
          <v-btn icon @click="prev()">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>

          <v-spacer></v-spacer>

          <v-btn
            outlined
            class="mr-4"
            color="white"
            @click="setToday"
          >
            Heute
          </v-btn>

          <v-menu offset-y :close-on-content-click="false" class="bg-primary">
            <template v-slot:activator="{ on, attrs }">
              <v-btn dark v-bind="attrs" v-on="on" outlined>
                <v-icon>mdi-cog</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item>
                <v-select 
                  v-model="mode" 
                  :items="types" 
                  item-text="name"
                  item-value="value"
                  dense 
                  outlined 
                  hide-details 
                  class="ma-2"
                  label="Ansicht"></v-select>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-spacer></v-spacer>

          <v-btn icon @click="next()">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>



          <span v-if="lastSyncLabel" class="caption white--text mr-2" style="opacity: 0.7;">
            {{ lastSyncLabel }}
          </span>
          <v-btn text @click="sync()" :loading="loading">
            <v-icon>mdi-sync</v-icon>
          </v-btn>
          <v-btn v-if="isAdmin" text @click="$router.push('/admin')">
            <v-icon>mdi-chart-bar</v-icon>
          </v-btn>
          <v-btn text @click="logout">
            <v-icon>mdi-logout</v-icon>
          </v-btn>
        </v-sheet>
          <v-calendar v-model="focus" ref="calendar" type="custom-daily" :start="start" :end="end" :events="data" @click:event="showEvent" first-time="06:00" :interval-count="32" :interval-minutes="30" :interval-format="formatTime" @click:day="dayClick">
          <!-- <v-calendar v-model="today" ref="calendar" :events="data" :weekdays="weekday" color="primary" :type="type"
            class="mt-2" @click:event="showEvent" firstTime="06:00" endTime="21:00" light :max-days="max_days"> -->
            <template v-slot:day-label-header="{ day, month }">
              <v-btn 
                color="primary"
                outlined
                dark
                class="my-1"
                v-if="day == new Date().getDate() && month == new Date().getMonth() + 1"
              >
                {{ day }}.{{ month < 10 ? "0" + month : month }}
              </v-btn>
              <v-btn 
                v-else
                text
                class="my-1"
                >{{ day }}.{{ month < 10 ? "0" + month : month }}</v-btn>
            </template>
            <template v-slot:event="{ event }">
              <b class="ma-1">{{ event.name }}</b>
            </template>
            <template v-slot:day-body="{ date, week }">
              <div
                class="v-current-time"
                :class="{ first: date === week[0].date }"
                :style="{ top: nowY }"
              ></div>
            </template>
          </v-calendar>
          <v-menu v-model="selectedOpen" :close-on-content-click="false" :activator="selectedElement" offset-x>
            <v-card color="grey lighten-4" flat>
              <v-toolbar color="primary" dark>
                <v-toolbar-title>{{ selectedEvent.name }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="selectedOpen = false">
                  <v-icon>mdi-window-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text>
                <v-row>
                  <v-col>Event: </v-col><v-col>{{ selectedEvent.event }}</v-col>
                </v-row>
                <v-row>
                  <v-col>Name: </v-col><v-col>{{ selectedEvent.name }}</v-col>
                </v-row>
                <v-row>
                  <v-col>Start: </v-col><v-col>{{ selectedEvent.start }}</v-col>
                </v-row>
                <v-row>
                  <v-col>Ende: </v-col><v-col>{{ selectedEvent.end }}</v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-menu>
      </v-col>
    </v-row>

    <v-btn @click="prev()" fab x-large left bottom fixed color="primary" dark>
      <v-icon>mdi-chevron-left</v-icon>
    </v-btn>
    <v-btn @click="next()" fab x-large right bottom fixed color="primary" dark>
      <v-icon>mdi-chevron-right</v-icon>
    </v-btn>

    <v-snackbar v-model="syncErrorVisible" color="error" :timeout="5000" bottom>
      {{ $store.state.syncError }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="syncErrorVisible = false">Schließen</v-btn>
      </template>
    </v-snackbar>

    <v-dialog v-model="loading" persistent width="300">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">Lade Daten ...</v-card-title>
        <v-card-text align="center" class="pt-5">
          <v-progress-circular
            :indeterminate="true"
            color="primary"
            >
        </v-progress-circular>
        </v-card-text>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import Cookies from "js-cookie"

function getMonday(dateStr) {
  let date = new Date(dateStr);
  let day = date.getDay()
  if (day == 1) {
    return dateStr;
  }

  // Calculate the difference to the previous Monday
  const daysToMonday = (day === 0) ? 6 : day - 1;

  // Subtract the difference in days from the current date
  date.setDate(date.getDate() - daysToMonday);

  // Format the date back to "YYYY-MM-DD" string format
  const mondayStr = date.toISOString().split('T')[0];
  return mondayStr;
}

function getThursday(dateStr) {
    const date = new Date(dateStr);
    const dayOfWeek = date.getDay();

    if (dayOfWeek === 4) {
        return dateStr;
    }

    const daysToThursday = (dayOfWeek <= 4) ? 4 - dayOfWeek : 4 - dayOfWeek + 7;

    date.setDate(date.getDate() + daysToThursday);

    const thursdayStr = date.toISOString().split('T')[0];
    return thursdayStr;
}

function getFriday(dateStr) {
    // Convert the input string to a Date object
    const date = new Date(dateStr);
    const dayOfWeek = date.getDay();

    if (dayOfWeek === 5) {
        return dateStr;
    }

    const daysToFriday = (dayOfWeek <= 5) ? 5 - dayOfWeek : 5 - dayOfWeek + 7;

    date.setDate(date.getDate() + daysToFriday);

    const fridayStr = date.toISOString().split('T')[0];
    return fridayStr;
}

export default {
  name: 'HomeView',

  components: {},
  data: () => ({
    lastSyncLabel: '',
    lastSyncTimer: null,
    syncErrorVisible: false,
    focus: '',
    selectedEvent: {},
    selectedElement: null,
    dialog: true,
    selectedOpen: false,
    types: [
      {
        name: "Mo - Do",
        value: "4day"
      },
      {
        name: "Mo - Fr",
        value: "5day"
      },
      {
        name: "Tag",
        value: "day"
      }
    ],
    init_start: "",
    init_end: "",
    start: "2024-09-10",
    end: "2024-09-14",
    ready: false,
    mode: "4day"
  }),
  mounted() {
    this.$refs.calendar.scrollToTime('08:00')
    this.$store.dispatch("fetch");


    const today = new Date();
    const day = today.getDay();

    if (this.mode == "4day" || this.mode == "5day") {
      const monday = new Date(today);
      if (day === 6 || day === 0) {
          // If it's Saturday (6) or Sunday (0), move to next Monday
          const daysUntilNextMonday = day === 6 ? 2 : 1;  // 2 days for Saturday, 1 day for Sunday
          monday.setDate(today.getDate() + daysUntilNextMonday);
      } else {
          // Normal case: find this week's Monday
          const diff = day - 1; // Monday is day 1, adjust accordingly
          monday.setDate(today.getDate() - diff);
      }
      this.start = monday.toISOString().split('T')[0];
      this.init_start = this.start

      const thursday = new Date(monday);
      if (this.mode == "4day")
        thursday.setDate(monday.getDate() + 3);  // Thursday
      else
        thursday.setDate(monday.getDate() + 4);  // Friday

      this.end = thursday.toISOString().split('T')[0];
      this.init_end = this.end
    } else if (this.mode == "day") {
      this.start = new Date().toISOString().split('T')[0];
      this.init_start = this.start;
      this.end = new Date().toISOString().split('T')[0];
      this.init_end = this.end;
    }


    this.ready = true;
    this.lastSyncTimer = setInterval(() => {
      this.updateLastSyncLabel()
    }, 5000)
  },
  beforeDestroy() {
    if (this.lastSyncTimer) clearInterval(this.lastSyncTimer)
  },
  methods: {
    updateLastSyncLabel() {
      const ts = this.$store.state.lastSync
      if (!ts) { this.lastSyncLabel = ''; return }
      const secs = Math.floor((new Date() - ts) / 1000)
      if (secs < 60) this.lastSyncLabel = 'vor <1min'
      else if (secs < 3600) this.lastSyncLabel = `vor ${Math.floor(secs / 60)}min`
      else if (secs < 86400) this.lastSyncLabel = `vor ${Math.floor(secs / 3600)}h`
      else this.lastSyncLabel = `vor ${Math.floor(secs / 86400)}d`
    },
    prev() {
      if (this.mode == "4day" || this.mode == "5day") {
        let date = new Date(this.start);
        date.setDate(date.getDate() - 7);
        this.start = date.toISOString().split('T')[0];

        date = new Date(this.end);
        date.setDate(date.getDate() - 7);
        this.end = date.toISOString().split('T')[0];
      } else if (this.mode == "day") {
        if (this.allDates.length === 0) return;
        let date = new Date(this.start);
        let attempts = 0;
        do {
          date.setDate(date.getDate() - 1)
          attempts++;
        } while (!this.allDates.includes(date.toISOString().split('T')[0]) && attempts < 365)
        if (attempts < 365) {
          const d = date.toISOString().split('T')[0];
          this.start = d;
          this.end = d;
        }
      }
    },
    next() {
      if (this.mode == "4day" || this.mode == "5day") {
        let date = new Date(this.start);
        date.setDate(date.getDate() + 7);
        this.start = date.toISOString().split('T')[0];

        date = new Date(this.end);
        date.setDate(date.getDate() + 7);
        this.end = date.toISOString().split('T')[0];
      } else if (this.mode == "day") {
        if (this.allDates.length === 0) return;
        let date = new Date(this.start);
        let attempts = 0;
        do {
          date.setDate(date.getDate() + 1)
          attempts++;
        } while (!this.allDates.includes(date.toISOString().split('T')[0]) && attempts < 365)
        if (attempts < 365) {
          const d = date.toISOString().split('T')[0];
          this.start = d;
          this.end = d;
        }
      }
    },
    async sync() {
      try {
        await this.$store.dispatch("sync");
      } catch (e) {
        // error is stored in state.syncError
      }
    },
    setToday() {
      this.start = new Date().toISOString().split('T')[0];
      if (this.mode == "4day") {
        this.start = getMonday(this.start)
        this.end = getThursday(this.start)
      } else if (this.mode == "5day") {
        this.start = getMonday(this.start)
        this.end = getFriday(this.start)
      } else {
        this.end = this.start;
      }
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event
        this.selectedElement = nativeEvent.target
        requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
      }

      if (this.selectedOpen) {
        this.selectedOpen = false
        requestAnimationFrame(() => requestAnimationFrame(() => open()))
      } else {
        open()
      }

      nativeEvent.stopPropagation()
    },
    formatTime(date) {
      return date.time
    },
    logout() {
      Cookies.remove("session")
      Cookies.remove("user")
      Cookies.remove("is_admin")
      this.$store.state.user = ""
      this.$store.state.isAdmin = false
      this.$router.push("login")
    },
    dayClick({ date }) {
      this.start = date;
      this.end = date;
      this.mode = "day"
    }
  },
  computed: {
    loading() {
      return this.$store.state.loading;
    },
    isAdmin() {
      return this.$store.state.isAdmin;
    },
    data() {
      return this.$store.getters.preprocessed();
    },
    type: {
      get() {
        return this.$store.state.type;
      },
      set(val) {
        this.$store.state.type = val;
      }
    },
    weekday: {
      get() {
        return this.$store.state.weekday;
      },
      set(val) {
        this.$store.state.weekday = val;
      }
    },
    cal () {
      return this.ready ? this.$refs.calendar : null
    },
    nowY () {
      return this.cal ? this.$refs.calendar.timeToY(this.cal.times.now) + 'px' : '100px'
    },
    allDates() {
      return this.data.map((i) => {
        return new Date(i.start).toISOString().split('T')[0];
      })
    }
  },
  watch: {
    '$store.state.lastSync': function() {
      this.updateLastSyncLabel()
    },
    '$store.state.syncError': function(val) {
      if (val) this.syncErrorVisible = true
    },
    mode: function(val) {
      if (val == "day") {
        this.end = this.start;
      } else if (val == "4day" || val == "5day") {
        this.start = getMonday(this.start);
        if (val == "4day")
          this.end = getThursday(this.start)
        else
          this.end = getFriday(this.start)
      }
    }
  }
}
</script>

<style>
.v-current-time {
height: 2px;
background-color: #ea4335;
position: absolute;
left: -1px;
right: 0;
pointer-events: none;

&.first::before {
  content: '';
  position: absolute;
  background-color: #ea4335;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-top: -5px;
  margin-left: -6.5px;
}
}

.v-calendar-daily__pane, .v-calendar-daily__scroll-area {
  overflow-x: hidden;
  overflow-y: hidden;
}
</style>
